// Imports


// Plugins
const plugins = [{
  location: "/opt/letsplay/famsch/default/node_modules/react-static-plugin-sass",
  plugins: [],
  hooks: {}
},
{
  location: "/opt/letsplay/famsch/default",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins